<template>
  <hitvBindLogin
    class="mp-login"
    :fetchParams="fetchParams"
    v-if="showLogin"
    size="mini"
    :visible.sync="showLogin"
    @handleLoginSuccess="handleLoginSuccess"
  />
</template>

<script>
import HitvBindLogin from "mgtv-login-white";
import cookie from "js-cookie";

export default {
  name: "MgtvPCLogin",

  components: { HitvBindLogin },

  data() {
    return {
      fetchParams: {
        _support: "10000000",
        appVersion: window.VERSION,
        dname: "",
        src: "mgtv",
        invoker: "pcweb",
      },
      showLogin: false,
    };
  },

  watch: {
    showLogin: {
      handler() {
        if (!this.showLogin) {
          clearTimeout(this.timer);
        }
      },
    },
  },

  mounted() {
    this.bindEvents();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    bindEvents() {
      this.$EventBus.$on("showLogin", (showLogin) => {
        this.showLogin = showLogin;

        if (showLogin) {
          this.checkLogin();
        }
      });
    },
    getToken() {
      return cookie.get("HDCN");
    },
    /**检查登陆态 */
    checkLogin() {
      const token = this.getToken();

      if (token) {
        this.handleLoginSuccess(token);
        return;
      }

      this.timer = setTimeout(() => {
        this.checkLogin();
      }, 200);
    },
    handleLoginSuccess() {
      clearTimeout(this.timer);

      const token = this.getToken();
      if (token) {
        window.location.reload(true);
      }
    },
  },
};
</script>

<style lang="less"></style>
